"use client";

import { Typography } from "@/components/ui/typography";
import type { UseCaseIndustriesProps } from "./types";
import { memo } from "react";
import { cn } from "@/lib/utils";
import IndustryCardsCarousel from "@/components/screen/global-components/industry/IndustryCardsCarousel";
import { useCaseIndustriesData } from "./constants";

const UseCaseIndustries = ({ className }: UseCaseIndustriesProps) => {
  const { title, description, cards } = useCaseIndustriesData;

  return (
    <section className={cn("section overflow-hidden", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          <Typography variant="subHeadingSm" className="text-gray-600" asChild>
            <p>{description}</p>
          </Typography>
        </div>
        <IndustryCardsCarousel cards={cards} className="mt-6 lg:!mt-12" />
      </div>
    </section>
  );
};

export default memo(UseCaseIndustries);
